<template>
  <div class="home">
    <Header/>
    <div>
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        background="#ababab"
        img-width="100%"
        img-height="450"
        style="text-shadow: 1px 1px 2px #333;"
       @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
        >
         <b-carousel-slide>
            <template v-slot:img>
              <img
                class="img_slide"
                width="100%"
                height="90%"
                src="../assets/img/capa-site 01.jpg"
                alt="image slot"
              >
            </template>
          </b-carousel-slide>
          <b-carousel-slide>
             <template v-slot:img>
               <img
                 class="img_slide"
                 width="100%"
                 height="90%"
                 src="../assets/img/capa-site 02.jpg"
                 alt="image slot"
               >
             </template>
           </b-carousel-slide>
        </b-carousel>
    </div>
    <div id="main"><br>
      <div class="titulo_roxo_esquerdo">
        <h5 class="txt_">Sobre o Sapiência</h5>
      </div>
      <div id="sobre">
        <div class="img_turma">
          <img alt="aprovados" class="img_turma" src="../assets/galeria/quemsomos.jpg">
        </div><br>
        <div id="txt_sapiencia">
          <p class="p_sobre">A missão do Sapiência é guiar o aluno em seus estudos, permitindo alto aprofundamento nos conteúdos, através de um contato direto com seu professor, recebendo orientação individualizada, acesso a material didático qualificado e recursos audiovisuais e tecnológicos que oferecem suporte adequado para cada aluno desenvolver suas múltiplas inteligências.
          O Cursinho Sapiência acredita na capacidade do ser humano em vencer dificuldades e trilhar caminhos rumo ao seu sonho profissional, pois estudar não é para o agora é para a vida!</p><br>
          <br> <router-link to="/about" class="btn_li"><button id="see_more" type="button" to="/about"> Leia mais </button> </router-link>
        </div>
      </div>
      <hr>
      <div id="aprovados">
        <div class="titulo_roxo_esquerdo">
          <h5 class="txt_">Nossas Corujinhas</h5>
        </div>
        <div id="img_aprovados">
          <img alt="aprovados" id="imag" src="../assets/img/alunos aprovados.jpg">
        </div>
      </div>
      <hr>
      <div id="noticias">
        <h2 id="txt_location">Notícias<font-awesome-icon :icon="['fas','newspaper']" class="icon_spot" /></h2>
        <carousel
          v-if="info"
          :nav="false"
          :autoplay="true"
          :responsive="{0:{items:1,nav:false},800:{items:4,nav:false}}"
        >
          <div class="item" v-for="noticia in news">
            <b-col>
              <b-card
                v-bind:img-src="noticia.imagem"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 22rem;"
                class="mb-2"
              >
                <b-card-text>
                  <p v-html="noticia.titulo" class="txt_endereco"> </p>
                </b-card-text>
                <router-link v-bind:to="'/noticias/' + noticia.id" class="li"><div style="justify-content:center;display:flex"> <b-button pill variant="outline-secondary" id="btn_ver">Leia mais</b-button></div></router-link>
              </b-card>
            </b-col>
          </div>
        </carousel>
        </div>
        <hr>
        <h2 id="txt_location"> Localização <font-awesome-icon icon="map-marker-alt" class="icon_spot"/> </h2>
        <GoogleMapLoader> </GoogleMapLoader>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import GoogleMapLoader from '../components/GoogleMapLoader.vue'
import carousel from 'vue-owl-carousel'
import Vue from 'vue';

export default {
  name: 'home',
  data() {
    return {
      news:[],
      info: false,
      swiperOption: {
        pagination: {

          el: '.swiper-pagination',
          id:0,
          // dynamicBullets: true
        }
      },
      slide: 0,
      sliding: null,
    }
  },
  methods: {
    pegarNoticias(){
      var vm = this;
      let axiosConfig = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin": "*",
        }
      };
      this.axios
        .post('https://cursinhosapiencia.com.br/noticias.php' , axiosConfig)
        .then(response => {
          this.news = response.data
          this.info = true
        })
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  },
  components: {
    Header,
    Footer,
    GoogleMapLoader,
    carousel
  },
  mounted(){
    FB.XFBML.parse();
    this.pegarNoticias()
  }
}

</script>

<style media="screen">
@import "../assets/style_padrao.css";
  #fb {
    justify-content: center;
    display: flex;
    margin-bottom: 5%;
  }
  #fb-page{
    width: 90%;
  }
  .card-img-top {
    width: 100%;
    height: 15vw;
    object-fit: cover;
  }
  #customers {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 80%;
  }
  #customers td, #customers th {
    border: 1px solid #ddd;
    padding: 8px;
  }
  #customers tr:nth-child(even){background-color: #f2f2f2;}
  #customers tr:hover {background-color: #ddd;}
  #customers th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #7435af;
    color: white;
  }
  #see_more{
    background-color:yellowgreen;
    border-radius: 25px;
    color:white;
    border:none;
    width: 20%;
    font-size: 15px;
    height: 30px;
  }
  #see_more:hover{
    background-color:#32CD32;
  }
  .btn_li{
    justify-content: center;
    display: flex;
    width: 100%;
    text-decoration: none;
    color:white;
  }
  .btn_li:hover{
    text-decoration: none;
    color:white;
  }
  .map_location{
    width: 100%;
  }
  .slider {
    width: auto;
    height:auto;
    text-align: center;
    overflow: hidden;
  }
  .slides {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }
  .slides::-webkit-scrollbar {
    width: 10px;
    height: 6px;
  }
  .slides::-webkit-scrollbar-thumb {
    background: purple;
    border-radius: 5px;
  }
  .slides::-webkit-scrollbar-track {
    background: transparent;
  }
  .slides > div {
    scroll-snap-align: start;
    flex-shrink: 0;
    height: auto;
    margin-right: 50px;
    border-radius: 10px;
    transform-origin: center center;
    transform: scale(1);
    transition: transform 0.5s;
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }
  .slides > div:target {
  /*   transform: scale(0.8); */
  }
  .slider > a {
    display: inline-flex;
    width: 1.5rem;
    height: 1.5rem;
    background: white;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 0 0.5rem 0;
    position: relative;
  }
  .slider > a:active {
    top: 1px;
  }
  .slider > a:focus {
    background: #000;
  }
  /* Don't need button navigation */
  @supports (scroll-snap-type) {
    .slider > a {
      display: none;
    }
  }
  #main{
    width: 90%;
    margin:0 auto ;
    /* display: block; */
    height: auto;
  }
  #aprovados{
    margin-top:5%;
    display: block;
    width: 100%;
    height: auto;
    padding-bottom:5%;
  }
  #img_aprovados{
    padding-top: 2%;
    justify-content: center;
    display: flex;
  }
  #imag{
    width: 50%;
    height: 50%;
    margin-top: 1%;
  }
  .titulo_roxo_esquerdo{
    background: #7435af;
    display: flex;
    padding-bottom: 1%;
    padding-top: 2%;
    padding-right: 2%;
    align-items: center;
    margin-top: 5%;
    padding-left: 10vw;
    color: white;
    width: fit-content;
    width: -moz-fit-content;
    border-bottom-right-radius: 15px;
    border-top-right-radius: 15px;
  }
  #txt_location{
    padding-top:5%;
    padding-bottom:5%;
    text-align: center;
  }
  p{
    text-align: center!important;
    line-height: 1.6;
  }
 .icon_spot{
   color:yellowgreen;
 }
  #localizacao{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
  }
  .img_location{
    width:40%;
  }
  #img_santos{
    border-radius: 35%;
    width: 50%;
    height: 70%;
    margin-left: 30%;
  }
  #img_sjc{
    width: 50%;
    height: 70%;
    border-radius: 35%;
    margin-left: 35%;
  }
  #sobre{
    margin-top:3%;
    display: flex;
    width: 100%;
    height: auto;
    padding-bottom:1%;
  }
  #txt_sapiencia{
    text-align: justify!important;
    width: 100%;
  }
  #txt{
    line-height: 1.8;
  }
  #img_turma{
    width:80%;
  }
  .txt_endereco{
    color: #4F4F4F;
  }
  .txt_{
    color: white;
  }
  #table{
    justify-content:center;
    display:flex;
  }
  @media only screen and (max-width: 800px) {
    .fb-page{
      width: 90%;
    }
    .card-img-top {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
    .txt_{
      font-size: 14px;
    }
    #txt_location{
      font-size: 20px;
    }
  }
  @media only screen and (max-width: 600px) {
    #see_more{
      width: 40%;
    }
    .img_location{
      width:100%;
    }
    #localizacao{
      width: 100%;
      height: auto;
      display: block;
    }
    #sobre{
      margin-top:3%;
      display: block;
      width: 100%;
      height: auto;
      padding-bottom:1%;
    }
    #img_turma {
      width: 100%;
    }
    #txt_sapiencia{
      font-size: 13px;
    }
    #costumers{
      width:10%!important;
    }
    #table{
      overflow-x:auto;
      display: block;
    }

  }
</style>
